/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-confusing-arrow */
/* eslint-disable no-else-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/react-in-jsx-scope */
import DateFormatter from 'components/DateFormatter';
import UserInfo from 'components/UserInfo';
import { TYPE_OF_OFFER_AND_DEMAND } from 'helper/constants';
import { convertDateTimeIntoEpochTime } from 'pages/OfferCoupons/constants';
import { Badge } from 'reactstrap';
import {
  currencyToLocal,
  NumberWithCommasFormat,
  ORDER_APPROVAL_STATUS,
} from 'utils/constants';
import * as Yup from 'yup';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setVendorDetails } from 'actions/vendorDetailsAction';

export const validationSchema = Yup.object({
  grade: Yup.object().required('Grade is required').nullable(),
  quantity: Yup.number()
    .typeError('Quantity should be a number')
    .required('Quantity is required')
    .test('Is positive?', 'Enter only positive number', (value) => value > 0),

  pendingQuantity: Yup.number().nullable(),
  invoiceInfo: Yup.array().of(
    Yup.object().shape({
      total: Yup.string()
        .nullable()
        .matches(/^\d*(\.\d{0,2})?$/, 'Please enter a valid amount'),
      invoiceFiles: Yup.mixed()
        .nullable()
        .test(
          'required-invoice-file',
          'Please Upload Invoice File',
          function (value) {
            const rootValues =
              this.options.from?.[1]?.value || this.options.context;
            const match = this.path?.match(/\[(\d+)\]/);
            const index = match ? parseInt(match[1], 10) : 0;
            const logisticStatus =
              rootValues?.orderLogistics?.[index]?.orderLogisticStatus ||
              rootValues?.status;
            if (
              logisticStatus === 'DISPATCHED' ||
              logisticStatus === 'DELIVERED'
            ) {
              if (!value) return false;
              if (Array.isArray(value)) return value.length > 0;
              if (typeof value === 'string') return value.trim().length > 0;
              return Boolean(value);
            }
            return true;
          },
        ),
    }),
  ),
  orderLogistics: Yup.array().of(
    Yup.object().shape({
      driverName: Yup.string().trim(),
      driverNumber: Yup.string()
        .matches(
          /^[6-9]\d{9}$/,
          'Driver number must be 10 digits and start with 6, 7, 8 or 9',
          { excludeEmptyString: true },
        )
        .trim(),
      vehicleNumberImage: Yup.mixed()
        .nullable()
        .test(
          'required-vehicle-image',
          'Vehicle number image is required',
          (value) => {
            if (!value) return false;
            if (Array.isArray(value)) return value.length > 0;
            if (typeof value === 'string') return value.trim().length > 0;
            return Boolean(value);
          },
        ),
      loadingImage: Yup.mixed()
        .nullable()
        .test(
          'required-loading-image',
          'Loading image is required',
          (value) => {
            if (!value) return false;
            if (Array.isArray(value)) return value.length > 0;
            if (typeof value === 'string') return value.trim().length > 0;
            return Boolean(value);
          },
        ),
      loadingQty: Yup.number()
        .transform((value, originalValue) =>
          originalValue === '' ||
          originalValue === null ||
          originalValue === undefined
            ? undefined
            : value,
        )
        .typeError('Loading quantity should be a number')
        .required('Loading quantity is required')
        .test(
          'is-positive',
          'Loading quantity must be greater than 0',
          (value) => value > 0,
        )
        .test(
          'total-loadingQty',
          'Total loading quantity must be less than or equal to pending quantity',
          (values, context) => {
            if (!values) return true;
            const { orderLogistics, quantity } =
              context?.options?.context || {};
            if (!orderLogistics || !quantity) return true;

            // Calculate the total loading quantity
            const totalLoadedQty =
              orderLogistics &&
              orderLogistics.reduce(
                (total, logistics) =>
                  parseFloat(total) + (parseFloat(logistics.loadingQty) || 0),
                0,
              );
            return totalLoadedQty <= quantity;
          },
        ),
      // .test(
      //   'matchingUnit',
      //   'Loading quantity unit must match quantity unit',
      //   (value, context) => {
      //     // console.log('value', value);
      //     const { quantityUnit, orderLogistics } = context?.options?.context;

      //     const found =
      //       orderLogistics &&
      //       orderLogistics.some(
      //         (logistics) => logistics.loadingQtyUnit === quantityUnit?.id,
      //       );
      //     return found;
      //   },
      // ),
      // .test(
      //   'GreaterThanZero',
      //   'Loading quantity unit must match quantity unit',
      //   (value, context) => {
      //     console.log('value', value);
      //     const { quantityUnit, orderLogistics } = context?.options?.context;

      //     const found =
      //       orderLogistics &&
      //       orderLogistics.some(
      //         (logistics) => logistics.loadingQtyUnit === quantityUnit?.id
      //       );
      //     return found;
      //   }
      // ),
      // loadingQtyUnit: Yup.string(), // Add this validation

      vehicleNumber: Yup.string()
        .required('Vehicle number is required')
        .matches(
          /^[A-Za-z]{2}\d{2}[A-Za-z]{1,2}\d{4}$/,
          'Enter a valid vehicle number, e.g. MP09AB1234',
        )
        .max(10, 'Vehicle number can be maximum 10 characters')
        .trim(),

      deliveryDate: Yup.date()
        .nullable()
        .transform((value, originalValue) => (originalValue ? value : null))
        .test(
          'delivery-date-after-order-date',
          'Delivery date cannot be earlier than the order date',
          function (value) {
            if (!value) return true;

            const rootValues = this.options.from?.[1]?.value;
            const orderDate = rootValues?.createdAt;
            if (!orderDate) return true;

            const delivery = new Date(value);
            const order = new Date(
              typeof orderDate === 'number' && orderDate < 100000000000
                ? orderDate * 1000
                : orderDate,
            );

            delivery.setHours(0, 0, 0, 0);
            order.setHours(0, 0, 0, 0);
            return delivery >= order;
          },
        ),
    }),
  ),
  // .when('loadingQty', (target, schema) => {
  //   // console.log("target ", target, schema);
  //   const total = Number(target);

  //   return schema

  //     // .max(total, `Rewards must not exceed more than ${total}`)

  //     // .positive('Please enter a valid reward')

  //     // .integer('Please enter a valid reward')

  //     .required('Rewards is required');

  // })
  // deliveryAddress: Yup.object()
  //   .shape({
  //     country: Yup.mixed().required('Country is required'),
  //     state: Yup.mixed().required('State is required'),
  //     // area: Yup.string().trim(),
  //     // city: Yup.mixed().required('City is required'),
  //     pinCode: Yup.string()
  //       .required('Pincode is required')
  //       .matches(/^\d{6}$/, 'Pincode must be 6 digits')
  //       .trim(),
  //   })
  //   .nullable(),
});

export function dateToMilliseconds(dateString) {
  if (!dateString) return new Date().getTime();
  if (typeof dateString === 'number') {
    return dateString < 10000000000 ? dateString * 1000 : dateString;
  }
  const date = new Date(dateString);
  const time = date.getTime();
  return Number.isNaN(time) ? new Date().getTime() : time;
}

export const deliveredQuantityValidationSchema = Yup.object({
  deliveredQuantity: Yup.number('Enter the Delivered Quantity')
    .required('Delivered Quantity is required')
    .integer('Delivered Quantity must be an integer')
    .min(1, 'Delivered Quantity must be greater than 0'),
});

export const calculatePendingQty = (orderLogistics) => {
  const totalLoadedQty =
    orderLogistics &&
    orderLogistics.reduce(
      (total, logistics) =>
        parseFloat(total) + (parseFloat(logistics.loadingQty) || 0),
      0,
    );
  return totalLoadedQty;
};

const getTraderContactName = (trader) =>
  [trader?.firstName, trader?.middleName, trader?.lastName]
    .filter(Boolean)
    .join(' ');

const getTraderCompanyName = (trader) =>
  trader?.entityName || getTraderContactName(trader) || 'N/A';

const getTraderSubName = (trader) => {
  const companyName = trader?.entityName || '';
  const contactName = getTraderContactName(trader);

  if (!contactName || contactName === companyName) return '';
  return contactName;
};

const getTraderPhoneNumber = (trader) => {
  const callingCode = trader?.callingCode?.callingCode;
  const phone = trader?.phone;

  if (callingCode && phone) return `${callingCode}-${phone}`;
  return callingCode || phone || '';
};

const getVendorId = (value) => {
  const parsed = parseInt(value, 10);
  return Number.isNaN(parsed) ? null : parsed;
};

const VendorClickableUserInfo = ({
  vendorId,
  name,
  contactName,
  mobileNumber,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleOpen = useCallback(() => {
    if (!vendorId) return;
    dispatch(
      setVendorDetails({
        status: true,
        selectedVendor: {
          id: vendorId,
          entityName: name || '',
        },
      }),
    );
    navigate('/vendors');
  }, [dispatch, navigate, vendorId, name]);

  if (!vendorId) {
    return (
      <UserInfo
        name={name}
        contactName={contactName}
        mobileNumber={mobileNumber}
      />
    );
  }

  return (
    <div
      className="cursor-pointer market-user-link"
      onClick={handleOpen}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleOpen();
        }
      }}
      role="button"
      tabIndex={0}
    >
      <UserInfo
        name={name}
        contactName={contactName}
        mobileNumber={mobileNumber}
      />
    </div>
  );
};

export const orderedColumns = [
  // { accessorKey: '', header: 'S.No.', enableSorting: true },
  { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
  { accessorKey: 'id', header: 'ORDER ID', enableSorting: true },

  {
    accessorKey: 'seller',
    header: 'SELLER',
    cell: ({ row }) => (
      <VendorClickableUserInfo
        vendorId={getVendorId(row?.original?.seller?.id)}
        name={getTraderCompanyName(row?.original?.seller)}
        contactName={getTraderSubName(row?.original?.seller)}
        mobileNumber={getTraderPhoneNumber(row?.original?.seller)}
      />
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'buyer',
    header: 'BUYER',
    cell: ({ row }) => (
      <VendorClickableUserInfo
        vendorId={getVendorId(row?.original?.buyer?.id)}
        name={getTraderCompanyName(row?.original?.buyer)}
        contactName={getTraderSubName(row?.original?.buyer)}
        mobileNumber={getTraderPhoneNumber(row?.original?.buyer)}
      />
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'grade.name',
    header: 'GRADE',
    cell: ({ row }) => (
      <Badge color="primary">{row?.original?.grade?.name}</Badge>
    ),
    enableSorting: true,
  },
  {
    header: 'LOCATION',
    id: 'city?.cityName',
    cell: ({ row }) => (
      <>
        <div className="mb-1">
          {row?.original?.city?.cityName
            ? row?.original?.city?.cityName
            : row?.original?.portOfDischarge?.name}
        </div>
        <div className="font-manrope text-active text-nowrap">
          {row?.original?.state?.stateName}
        </div>
      </>
    ),
    enableSorting: false,
  },

  {
    accessorKey: 'rate',
    header: 'RATE',
    cell: ({ row }) => (
      <div className="text-nowrap">
        {`${currencyToLocal(row?.original?.rate, row?.original?.rateUnit?.isoCurrencyCode)}/KG`}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'quantity',
    header: 'ORDERED QTY',
    cell: ({ row }) => (
      <div>
        {NumberWithCommasFormat(row?.original?.quantity)}
        {row?.original?.quantityUnit}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'pendingQuantity',
    header: 'Pending QTY',
    cell: ({ row }) => (
      <div>
        {NumberWithCommasFormat(row?.original?.pendingQuantity)}
        {row?.original?.quantityUnit}
      </div>
    ),
    enableSorting: true,
  },

  {
    accessorKey: 'createdAt',
    header: 'booking date',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
    enableSorting: true,
  },
  {
    accessorKey: 'sellerCommissionAmount',
    header: 'Seller Commission',
    cell: ({ row }) => (
      <div>
        {currencyToLocal(
          row?.original?.sellerCommissionAmount,
          row?.original?.rateUnit?.isoCurrencyCode,
        )}
      </div>
    ),
    enableSorting: true,
  },

  {
    accessorKey: 'approvalStatus',
    header: 'APPROVAL STATUS',
    cell: ({ row }) => (
      <div className="text-center">
        {ORDER_APPROVAL_STATUS?.[row?.original?.approvalStatus]}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'deliveryDate',
    header: 'delivery date',
    cell: ({ row }) => (
      <>
        {row?.original?.offer ? (
          row?.original?.offer.offerType === TYPE_OF_OFFER_AND_DEMAND.LIVE ? (
            'N/A'
          ) : row?.original?.offer.offerType ===
            TYPE_OF_OFFER_AND_DEMAND.FORWARD ? (
            <>
              <DateFormatter
                dateTime={row?.original?.forwardOffer?.minDeliveryDelay}
              />{' '}
              -{' '}
              <DateFormatter
                dateTime={row?.original?.forwardOffer?.maxDeliveryDelay}
              />
            </>
          ) : row?.original?.foreignOffer?.minShipmentDelay ? (
            <>
              <DateFormatter
                dateTime={row?.original?.foreignOffer?.minShipmentDelay}
              />
              -{' '}
              <DateFormatter
                dateTime={row?.original?.foreignOffer?.maxShipmentDelay}
              />
            </>
          ) : (
            'N/A'
          )
        ) : row?.original?.demand ? (
          row?.original?.demand?.demandType ===
          TYPE_OF_OFFER_AND_DEMAND.LIVE ? (
            'N/A'
          ) : row?.original?.demand.demandType ===
            TYPE_OF_OFFER_AND_DEMAND.FORWARD ? (
            <>
              <DateFormatter
                dateTime={row?.original?.forwardDemand?.minDeliveryDelay}
              />{' '}
              -{' '}
              <DateFormatter
                dateTime={row?.original?.forwardDemand?.maxDeliveryDelay}
              />
            </>
          ) : (
            <>
              <DateFormatter
                dateTime={row?.original?.foreignDemand?.minDeliveryDelay}
              />{' '}
              -{' '}
              <DateFormatter
                dateTime={row?.original?.foreignDemand?.maxDeliveryDelay}
              />
            </>
          )
        ) : (
          'N/A'
        )}
      </>
    ),

    enableSorting: true,
  },
  {
    accessorKey: 'PaymentStatus',
    header: 'Payment Status',
    enableSorting: true,
  },
  // { accessorKey: 'status', header: 'STATUS', enableSorting: true },
  {
    accessorKey: 'createdByUserId',
    header: 'Created User ID',
    enableSorting: true,
  },
  {
    accessorKey: 'updatedByUserId',
    header: 'Updated User ID',
    enableSorting: true,
  },
  { accessorKey: 'orderType', header: 'ORDER TYPE', enableSorting: true },
  {
    accessorKey: 'offer',
    header: 'TYPE',
    enableSorting: false,
    cell: ({ row }) => (
      <>
        {row?.original?.offer?.offerType
          ? row?.original?.offer?.offerType
          : row?.original?.demand?.demandType}
      </>
    ),
  },
  { accessorKey: 'actions', header: 'ACTION', enableSorting: true },
];

export const deliveredOrderColumns = [
  { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
  { accessorKey: 'id', header: 'ORDER ID', enableSorting: true },
  {
    accessorKey: 'seller',
    header: 'SELLER',
    cell: ({ row }) => (
      <VendorClickableUserInfo
        vendorId={getVendorId(row?.original?.seller?.id)}
        name={getTraderCompanyName(row?.original?.seller)}
        contactName={getTraderSubName(row?.original?.seller)}
        mobileNumber={getTraderPhoneNumber(row?.original?.seller)}
      />
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'buyer',
    header: 'BUYER',
    cell: ({ row }) => (
      <VendorClickableUserInfo
        vendorId={getVendorId(row?.original?.buyer?.id)}
        name={getTraderCompanyName(row?.original?.buyer)}
        contactName={getTraderSubName(row?.original?.buyer)}
        mobileNumber={getTraderPhoneNumber(row?.original?.buyer)}
      />
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'grade.name',
    header: 'GRADE',
    cell: ({ row }) => (
      <Badge color="primary">{row?.original?.grade?.name}</Badge>
    ),
    enableSorting: true,
  },
  {
    header: 'LOCATION',
    id: 'city?.cityName',
    cell: ({ row }) => (
      <>
        <div className="mb-1">
          {row?.original?.city?.cityName
            ? row?.original?.city?.cityName
            : row?.original?.portOfDischarge?.name}
        </div>
        <div className="font-manrope text-active text-nowrap">
          {row?.original?.state?.stateName}
        </div>
      </>
    ),
    enableSorting: false,
  },
  {
    accessorKey: 'rate',
    header: 'RATE',
    cell: ({ row }) => (
      <div className="text-nowrap">
        {`${currencyToLocal(row?.original?.rate, row?.original?.rateUnit?.isoCurrencyCode)}/KG`}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'quantity',
    header: 'ORDERED QTY',
    cell: ({ row }) => (
      <div>
        {NumberWithCommasFormat(row?.original?.quantity)}
        {row?.original?.quantityUnit}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'pendingQuantity',
    header: 'Pending QTY',
    cell: ({ row }) => (
      <div>
        {NumberWithCommasFormat(row?.original?.pendingQuantity)}
        {row?.original?.quantityUnit}
      </div>
    ),
    enableSorting: true,
  },

  {
    accessorKey: 'deliveredQuantity',
    header: 'Delivered QTY',
    cell: ({ row }) => (
      <div>
        {NumberWithCommasFormat(row?.original?.deliveredQuantity)}
        {row?.original?.quantityUnit}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'deliveryDate',
    header: 'delivery date',
    cell: ({ row }) =>
      row?.original?.deliveryDate ? (
        <DateFormatter dateTime={row?.original?.deliveryDate} />
      ) : (
        <div className="text-center">N/A</div>
      ),
    enableSorting: true,
  },
  {
    accessorKey: 'sellerCommissionAmount',
    header: 'Seller Commission',
    cell: ({ row }) => (
      <div>
        {currencyToLocal(
          row?.original?.sellerCommissionAmount,
          row?.original?.rateUnit?.isoCurrencyCode,
        )}
      </div>
    ),
    enableSorting: true,
  },

  // { accessorKey: 'date', header: 'DATE', enableSorting: true  },

  // {
  //   accessorKey: 'approvalStatus',
  //   header: 'APPROVAL STATUS',
  //   cell: ({ row }) => (
  //     <div>{ORDER_APPROVAL_STATUS?.[row?.original?.approvalStatus]}</div>
  //   ),
  //   enableSorting: true,
  // },
  // { accessorKey: 'status', header: 'STATUS', enableSorting: true },
  {
    accessorKey: 'PaymentStatus',
    header: 'Payment Status',
    enableSorting: true,
  },
  {
    accessorKey: 'createdByUserId',
    header: 'Created User ID',
    enableSorting: true,
  },
  {
    accessorKey: 'updatedByUserId',
    header: 'Updated User ID',
    enableSorting: true,
  },
  { accessorKey: 'actions', header: '', enableSorting: true },
];

// Helper function to format epoch timestamp to date string
const formatEpochToDate = (epochTimestamp) => {
  if (!epochTimestamp) return '';
  // If timestamp is in seconds, convert to milliseconds
  const timestamp =
    epochTimestamp < 10000000000 ? epochTimestamp * 1000 : epochTimestamp;
  const date = new Date(timestamp);

  // Format as DD-MM-YYYY
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

export const convertEpochToDate = (epochTimestamp) => {
  if (!epochTimestamp) return '';
  // If timestamp is in seconds, convert to milliseconds
  const timestamp =
    epochTimestamp < 10000000000 ? epochTimestamp * 1000 : epochTimestamp;
  const date = new Date(timestamp);
  return date;
};
export const paymentDetailsColumns = [
  { accessorKey: 'utrNumber', header: 'UTR Number', enableSorting: false },
  {
    accessorKey: 'paidDate',
    header: 'Paid Date',
    enableSorting: false,
    cell: ({ row }) => {
      return formatEpochToDate(row?.original?.paidDate);
    },
  },
  {
    accessorKey: 'paidAmount',
    header: 'Paid Amount',
    enableSorting: false,
    cell: ({ row }) => {
      const amount = row?.original?.paidAmount;
      return amount.toLocaleString();
    },
  },
  {
    accessorKey: 'reciept',
    header: <div className="text-center">Receipt</div>,
    enableSorting: false,
  },
  {
    accessorKey: 'actions',
    header: 'ACTION',
    enableSorting: false,
  },
];

export const PAYMENT_METHODS = [
  'RTGS',
  'NEFT',
  'IMPS',
  'UPI',
  'NETBANKING',
  'CARDS',
  'CASH',
];

export const sellerPaymentDetailsColumns = [
  { accessorKey: 'utrNumber', header: 'UTR Number', enableSorting: false },
  {
    accessorKey: 'paidDate',
    header: 'Paid Date',
    enableSorting: false,
    cell: ({ row }) => {
      return formatEpochToDate(row?.original?.paidDate);
    },
  },
  {
    accessorKey: 'paidAmount',
    header: 'Paid Amount',
    enableSorting: false,
    cell: ({ row }) => {
      const amount = row?.original?.paidAmount;
      return amount?.toLocaleString();
    },
  },
  {
    accessorKey: 'paymentMethodStatus',
    header: 'MODE',
    enableSorting: false,
    cell: ({ row }) => {
      return (
        row?.original?.paymentMethodStatus ||
        row?.original?.paymentMethod ||
        '-'
      );
    },
  },
  {
    accessorKey: 'reciept',
    header: <div className="text-center">Receipt</div>,
    enableSorting: false,
  },
  {
    accessorKey: 'actions',
    header: 'ACTION',
    enableSorting: false,
  },
];

// export const orderInitialValues = () => {
//   return {
//     grade: '',
//     quantity: '',
//     billing_street_address: '',
//     billing_city: '',
//     billing_country: '',
//     billing_state: '',
//     delivery_street_address: '',
//     delivery_city: '',
//     delivery_country: '',
//     delivery_state: '',
//     driver_name: '',
//     phone_number: '',
//     vehicle_number: '',
//     transport_name: '',
//     transport_LR: '',
//     other_charges: '',
//     loading_charges: '',
//     frieght: '',
//     delivery_status: '',
//   };
// };

export const orderInitialValues = (value) => {
  const { id, grade, quantity } = value;
  return {
    id,
    grade: { id: grade?.id, label: grade?.name },
    quantity,
    billing_street_address: '',
    billing_city: '',
    billing_country: '',
    billing_state: '',
    delivery_street_address: '',
    delivery_city: '',
    delivery_country: '',
    delivery_state: '',
    driver_name: '',
    phone_number: '',
    vehicle_number: '',
    transport_name: '',
    transport_LR: '',
    other_charges: '',
    loading_charges: '',
    frieght: '',
    delivery_status: '',
  };
};

export const ORDERS_HEADING = {
  ORDERED: 'Ordered',
  DISPATCHED: 'Dispatched',
  DELIVERED: 'Delivered',
};

export const checkPending = (orderLogisticStatus) => {
  return orderLogisticStatus === 'IN_PROGRESS' ||
    orderLogisticStatus === 'PENDING' ||
    orderLogisticStatus === 'LOADING' ||
    orderLogisticStatus === 'DISPATCHED' ||
    orderLogisticStatus === 'DELIVERED'
    ? 'active'
    : '';
};

export const checkInProgress = (orderLogisticStatus) => {
  return orderLogisticStatus === 'IN_PROGRESS' ||
    orderLogisticStatus === 'LOADING' ||
    orderLogisticStatus === 'DISPATCHED' ||
    orderLogisticStatus === 'DELIVERED'
    ? 'active'
    : '';
};

export const checkLoading = (orderLogisticStatus) => {
  return orderLogisticStatus === 'LOADING' ||
    orderLogisticStatus === 'DISPATCHED' ||
    orderLogisticStatus === 'DELIVERED'
    ? 'active'
    : '';
};

export const checkDispatched = (orderLogisticStatus) => {
  return orderLogisticStatus === 'DISPATCHED' ||
    orderLogisticStatus === 'DELIVERED'
    ? 'active'
    : '';
};

export const deliveryStatus = (orderLogisticStatus) => {
  return orderLogisticStatus === 'DELIVERED' ? 'active' : '';
};

export const deliveryOption = [
  // { value: 'PENDING', label: 'Pending' },
  { value: 'IN_PROGRESS', label: 'InProgress' },
  { value: 'LOADING', label: 'Loading' },
  { value: 'DISPATCHED', label: 'Dispatched' },
  // { value: 'CANCELLED', label: 'Cancelled' },
  { value: 'DELIVERED', label: 'Delivered' },
];

export const ORDER_STATUS_FILTER = [
  { label: 'Pending', id: 'PENDING' },
  { label: 'InProgress', id: 'IN_PROGRESS' },
  { label: 'Loading', id: 'LOADING' },
  { label: 'Dispatched', id: 'DISPATCHED' },
  { label: 'Delivered', id: 'DELIVERED' },
];

export const processLogistics = (values, i) => {
  const Order = values.orderLogistics[i];
  Order.order = values.id;
  Order.rateUnit = values.rateUnit?.id;
  Order.callingCode = values?.orderLogistics?.[i]?.callingCode?.callingCode
    ? values?.orderLogistics?.[i]?.callingCode?.callingCode
    : null;
  Order.loadingImage = values?.orderLogistics?.[i]?.loadingImage;
  Order.lrDoc = values?.orderLogistics?.[i]?.lrDoc;
  Order.weightSlipDoc = Array.isArray(
    values?.orderLogistics?.[i]?.weightSlipDoc,
  )
    ? values?.orderLogistics?.[i]?.weightSlipDoc
    : [values?.orderLogistics?.[i]?.weightSlipDoc];
  Order.vehicleNumberImage = values?.orderLogistics?.[i]?.vehicleNumberImage;
  Order.deliveryDate = values?.orderLogistics?.[i]?.deliveryDate
    ? convertDateTimeIntoEpochTime(values?.orderLogistics?.[i]?.deliveryDate)
    : null;
  Order.loadingCharges = 0.0;
  Order.freight = 0.0;
  Order.logisticDeliveryTerm =
    values?.orderLogistics?.[i]?.logisticDeliveryTerm || '';
  delete Order.invoice;
  // eslint-disable-next-line no-underscore-dangle
  delete Order.__typename;
  // if (!Order?.id) delete Order.id;

  if (Order.pickupAddress) {
    Order.pickupAddress = {
      id: Order.pickupAddress?.id || null,
      city: Order.pickupAddress?.city?.id || null,
      country: Order.pickupAddress?.country?.id || null,
      state: Order.pickupAddress?.state?.id || null,
      street: Order.pickupAddress?.street || '',
      area: Order.pickupAddress?.area || '',
      houseNumber: Order.pickupAddress?.houseNumber || '',
      pinCode: Order.pickupAddress?.pinCode || '',
      user: values?.seller?.id || '',
    };
    // eslint-disable-next-line no-underscore-dangle
    delete Order.pickupAddress.__typename;
  }
  return Order;
};
